// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor2 from '@/game/prefabs/World/Mentors/Mentor2';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from '@/game/scenes/TilemapScenes/TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level30 extends TilemapScene {
  constructor() {
    super('Level30');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // spring_biome_7
    const spring_biome_7 = this.add.tilemap('spring-biome-7');
    spring_biome_7.addTilesetImage(
      'spring forest wang tiles',
      'spring forest wang tiles',
    );
    spring_biome_7.addTilesetImage('spring 32x32', 'spring 32x32');
    spring_biome_7.addTilesetImage(
      'spring water sparkles B',
      'spring water sparkles B',
    );

    // tilemapLayers
    const tilemapLayers = this.add.container(0, 0);

    // wang_Terrian_1
    const wang_Terrian_1 = spring_biome_7.createLayer(
      'Wang Terrian',
      ['spring forest wang tiles'],
      0,
      0,
    )!;
    tilemapLayers.add(wang_Terrian_1);

    // sparkles_1
    const sparkles_1 = spring_biome_7.createLayer(
      'Sparkles',
      ['spring water sparkles B'],
      0,
      0,
    )!;
    tilemapLayers.add(sparkles_1);

    // rocks_1
    const rocks_1 = spring_biome_7.createLayer(
      'Rocks',
      ['spring 32x32'],
      0,
      -12,
    )!;
    tilemapLayers.add(rocks_1);

    // portal
    const portal = new Portal(this, 346, 482);
    this.add.existing(portal);

    // player
    const player = new Player(this, 347, 42);
    this.add.existing(player);

    // mentor2
    const mentor2 = new Mentor2(this, 281, 63);
    this.add.existing(mentor2);

    // worldNode
    const worldNode = new WorldNode(this, 582, 169);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 210, 191);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 612, 372);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 463, 327);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 440, 459);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 63, 423);
    this.add.existing(worldNode_5);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 287, 263);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 658, 185);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 38, 207);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 429, 136);
    this.add.existing(worldNode_9);

    // forestTree1
    const forestTree1 = new ForestTree1(
      this,
      133,
      194,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(this, 58, 179, 'spring_trees_sheet', 1);
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(
      this,
      25,
      188,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      534,
      170,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(
      this,
      612,
      129,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      658,
      164,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      660,
      384,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      123,
      391,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      16,
      105,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      526,
      314,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      431,
      59,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      245,
      490,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      432,
      339,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      578,
      132,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      628,
      156,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      632,
      366,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      552,
      328,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      92,
      376,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      8,
      145,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      79,
      207,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(
      this,
      264,
      24,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_19);

    // forestTree_21
    const forestTree_21 = new ForestTree1(
      this,
      590,
      342,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(
      this,
      12,
      198,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(
      this,
      602,
      151,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_23);

    // forestTree_20
    const forestTree_20 = new ForestTree1(this, 171, 196, 'spring 32x', 0);
    this.add.existing(forestTree_20);

    // forestTree_24
    const forestTree_24 = new ForestTree1(this, 269, 389, 'spring 32x', 0);
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(this, 565, 158, 'spring 32x', 0);
    this.add.existing(forestTree_25);

    // forestTree_26
    const forestTree_26 = new ForestTree1(this, 88, 402, 'spring 32x', 0);
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(this, 47, 100, 'spring 32x', 0);
    this.add.existing(forestTree_27);

    // forestTree_28
    const forestTree_28 = new ForestTree1(this, 286, 247, 'spring 32x', 4);
    this.add.existing(forestTree_28);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 29;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 29;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 29;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 29;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 29;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 29;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 29;
    worldNode_6.NPCId = 6;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 29;
    worldNode_7.NPCId = 7;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 29;
    worldNode_8.NPCId = 8;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 29;
    worldNode_9.NPCId = 9;

    this.portal = portal;
    this.player = player;
    this.mentor2 = mentor2;
    this.worldNode = worldNode;
    this.worldNode_1 = worldNode_1;
    this.worldNode_2 = worldNode_2;
    this.worldNode_3 = worldNode_3;
    this.worldNode_4 = worldNode_4;
    this.worldNode_5 = worldNode_5;
    this.worldNode_6 = worldNode_6;
    this.worldNode_7 = worldNode_7;
    this.worldNode_8 = worldNode_8;
    this.worldNode_9 = worldNode_9;
    this.spring_biome_7 = spring_biome_7;

    this.events.emit('scene-awake');
  }

  private portal!: Portal;
  private player!: Player;
  private mentor2!: Mentor2;
  private worldNode!: WorldNode;
  private worldNode_1!: WorldNode;
  private worldNode_2!: WorldNode;
  private worldNode_3!: WorldNode;
  private worldNode_4!: WorldNode;
  private worldNode_5!: WorldNode;
  private worldNode_6!: WorldNode;
  private worldNode_7!: WorldNode;
  private worldNode_8!: WorldNode;
  private worldNode_9!: WorldNode;
  private spring_biome_7!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.spring_biome_7,
      portal: this.portal,
      mentor: this.mentor2,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
